var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:[
		'dropdown-toggle header-company-btn',
		{ 'active' : _vm.ulNameLocal }, { 'loader' : !_vm.ulNameLocal }
	],on:{"click":_vm.toggleDropdown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }